import type { DeckSummary } from './api'

/** Passed in router state when a test was started from the "Random" shortcut. */
export interface RandomPick {
  deckId: string
  title: string
}

/** Decks a test can start on: not archived or locked, and with at least one card. */
export function eligibleDecks(decks: DeckSummary[]): DeckSummary[] {
  return decks.filter(
    (deck) => (deck.status === 'ACTIVE' || deck.status === 'FLAGGED') && deck.cardCount > 0,
  )
}

/** Picks a random eligible deck, preferring one other than `excludeDeckId`. */
export function pickRandomDeck(decks: DeckSummary[], excludeDeckId?: string): DeckSummary | undefined {
  const eligible = eligibleDecks(decks)
  const others = eligible.filter((deck) => deck.deckId !== excludeDeckId)
  const pool = others.length > 0 ? others : eligible
  return pool[Math.floor(Math.random() * pool.length)]
}
